import { AuthRegisterForms } from 'src/components/AuthRegisterForms';
import { BaseIcon } from 'src/components/BaseIcon';
import React from 'react';
import { TLoginProps } from './Login.types';
import { routesConfig } from 'src/routes/routes.config';
import s from './Login.module.scss';
import { useHistory } from 'react-router';

export const Login: React.FC<TLoginProps> = () => {
  const history = useHistory();
  return (
    <div className={s.container}>
      <BaseIcon
        icon="gs-logo-white"
        size={80}
        className={s.logo}
        onClick={() => history.push(routesConfig.home())}
      />
      <AuthRegisterForms
        onSuccess={() => {
          history.push(routesConfig.myCommunities());
        }}
      />
    </div>
  );
};
